import { ReactComponent as LogoSTZ } from '@assets/logo.svg';
import styled from '@emotion/styled/macro';
import { colors } from '@assets/colors';

export const LogoStyled = styled(LogoSTZ)`
    border-radius: 6px;
    width: 150px;
    fill: ${colors.textWhite};
`;
